import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PortalTokenShell from './PortalTokenShell';
import PortalTokenHome from './PortalTokenHome';
import PortalMaintenanceForm from './PortalMaintenanceForm';
import PortalAccessForm from './PortalAccessForm';
import PortalDocumentsPage from './PortalDocumentsPage';

/**
 * Public router for /p/t/:token/* (mounted from index.js, parallel to tenant-portal).
 */
const PortalTokenApp = () => {
  return (
    <Routes>
      <Route path="/p/t/:token" element={<PortalTokenShell />}>
        <Route index element={<PortalTokenHome />} />
        <Route path="maintenance/new" element={<PortalMaintenanceForm />} />
        <Route path="access" element={<PortalAccessForm />} />
        <Route path="access/:eventId" element={<PortalAccessForm />} />
        <Route path="documents" element={<PortalDocumentsPage />} />
      </Route>
    </Routes>
  );
};

export default PortalTokenApp;
